import { c as _c } from "react/compiler-runtime";
import type { PrV2SkeletonLayout } from './use-pr-v2-skeleton-layout';
import { PR_V2_CONTENT_CLASS } from '../pr-v2-layout-classes';
import { PrV2ChangesPaneSkeleton, PrV2DescriptionSkeleton, PrV2HeaderSkeleton, PrV2ReviewSubheaderSkeleton, PrV2SidebarSkeleton } from './pr-v2-loading-sections';
import { cn } from '@/lib/utils';
export function PrV2LoadingSkeleton(t0) {
  const $ = _c(14);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    className,
    layout
  } = t1;
  let t2;
  if ($[2] !== className) {
    t2 = cn("space-y-0", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={PR_V2_CONTENT_CLASS}><PrV2HeaderSkeleton /></div>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== layout) {
    t4 = (!layout || layout.showAiSections) && <div className={cn("col-start-1 col-end-13 order-2 md:max-w-[320px] max-md:px-3 md:col-start-10 md:col-end-12 md:order-0 md:row-start-2", layout && (layout.chatSidebarOpen ? "3xl:-ml-40" : "2xl:-ml-40"))}><PrV2SidebarSkeleton /></div>;
    $[5] = layout;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className={cn(PR_V2_CONTENT_CLASS, "mt-2 order-3 md:order-0")}><PrV2DescriptionSkeleton /></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4) {
    t6 = <div className="bg-background pb-5 pt-6"><div className="grid w-full grid-cols-12 gap-4">{t3}{t4}{t5}</div></div>;
    $[8] = t4;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section><div className="grid min-h-screen w-full grid-cols-12 grid-rows-[auto_1fr] gap-y-0"><div className="col-span-full row-start-2 mt-0"><PrV2ReviewSubheaderSkeleton /><PrV2ChangesPaneSkeleton /></div></div></section>;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t6) {
    t8 = <div data-testid="pr-v2-loading-skeleton" className={t2}>{t6}{t7}</div>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}